<template>
    <div class="clearfix rounded pb-5 mx-auto other-settings">  <!-- Abdullah changed class here. was clearfix company-form-container rounded mt-4 pb-5 mx-auto other-settings -->

        <!-- Abdullah commented this  -->
        <!-- <div class=" justify-content-center py-2 mb-3 border-bottom ">
            <div class="col-sm-6 px-3 company-form-box-title">Other Settings</div>
        </div> -->

        <!-- Abdullah added this code  -->
        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">System Settings<span>
            <!-- AbdullahALC chnaged pageurl to api url -->
            <a v-bind:href="$api_url + '/company/dashboard'">Dashboard</a> / Settings / System Settings / Other
            Settings</span>
        </h4>

        <b-form @submit.stop.prevent="onSubmit">

            <!-- Abdullah commented this  -->
        <!-- <fieldset :disabled="disabled_by_acl">
            <b-overlay :show="showoverlay" rounded="sm">
            <div class="clearfix company-other-settings">
                <div class="col-md-12 px-3">


                    <div class="col-sm-6 company-form-box-title pl-0 mb-2">Decimal Places</div>
                    <p>Please select your desired option</p>
                    <div class="toggle_button_tax"  >
                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                            <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                <input data-v-25adc6c0="" type="radio" v-model="fdata.decimal_point_settings" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="yes" >
                                <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                    <div data-v-25adc6c0="" class="v-switch-button"></div></div> </label>
                        </div>
                        <div class="col-sm-3 trz_tax_button ">Yes - 2 decimal places</div>
                    </div>
                    <div class="toggle_button_tax">
                        <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                            <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                <input data-v-25adc6c0="" type="radio" v-model="fdata.decimal_point_settings" class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="no" >
                                <div data-v-25adc6c0="" class="v-switch-core" style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                    <div data-v-25adc6c0="" class="v-switch-button"></div></div> </label>
                        </div>
                        <div class="col-sm-3 trz_tax_button ">No - Rounded to closest integer.</div>
                    </div>


                    <div class="row mt-3" v-if="fdata.decimal_point_settings == 'no'">

                        <div class="col-md-6">
                            <div class="card h-100 red-shadow">
                                <div class="card-body">
                                    <h5 class="mb-3 border-bottom pb-3"><b-icon icon="info-circle" class="mr-2 align-custom"></b-icon>Disclaimer</h5>
                                    <p>Please note that rounding of figures may result in nominal differences due to the impact of fractions. accordHRM will not be responsible for any under or over deductions and/or payments due to such differences.</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="card h-100">
                                <div class="card-body">
                                    <h5 class="mb-3 border-bottom pb-3"><b-icon icon="info-circle" class="mr-2 align-custom"></b-icon>Rounding to the Nearest Integer</h5>
                                    <p>The most common type of rounding is to round to the nearest integer. The rule for rounding is simple; look at the digits in the tenth's place (the first digit to the right of the decimal point). If the digit in the tenths place is less than 5, then <strong>round down</strong>, which means the units digit remains the same: When digit in the tenths place is 5 or greater, then <strong>round up</strong>, which means you should increase the unit digit by one.</p>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div class="col-sm-6 company-form-box-title mt-3 pl-0 mb-2">Password Protection</div>
                    <b-form-group label="1.	Set master password for payslips and taxcards:" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="fdata.owner_password_settings"
                            :options="owner_p_setting_option"
                            :aria-describedby="ariaDescribedby"
                            name="owner_password_settings"
                            plain
                        ></b-form-radio-group>

                    </b-form-group>
                    <div class="row" v-if="fdata.owner_password_settings == 'yes'">
                        <div class="col-md-6">

                          <div class="row">
                              <div class="col-md-12">
                                    <b-input-group
                                    label="Password(4 characters minimum):"
                                    minlength="4"
                                    class="text-left mb-5 max-250">
                                    <b-form-input
                                    v-model="fdata.owner_password"
                                    :type="type"
                                    name="owner_password"
                                    placeholder="Enter your password"
                                    pattern=".{4,}"
                                    description="please enter a password "
                                    title="Password should be at least 4 characters long"
                                    required
                                    ></b-form-input>
                                     <b-input-group-append>
                                    <b-button variant="outline-success"  @click="showPassword()"><b-icon  icon="eye-fill"></b-icon></b-button>
                                    </b-input-group-append>
                                </b-input-group>

                              </div>
                          </div>

                        </div>
                    </div>

                </div>

                <div class="col-md-12 px-3">
                    <b-form-group label="2.	Password protect payslips and taxcards for employees:" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="fdata.employee_password_settings"
                            :options="employee_p_setting_option"
                            :aria-describedby="ariaDescribedby"
                            name="employee_password_settings"
                            plain
                        ></b-form-radio-group>
                    </b-form-group>
                    <div class="row" v-if="fdata.employee_password_settings == 'yes'">
                        <div class="col-md-12">
                          <b-form-group label="Select password type:" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="fdata.employee_passworod_type"
                            :options="employee_p_type_option"
                            :aria-describedby="ariaDescribedby"
                            name="employee_password_type"
                            class="employee-pass-settings mb-2"
                            plain
                        ></b-form-radio-group>
                    </b-form-group>
                        </div>
                    </div>
                    <div class="col-md-12 px-0">
                        <b-icon icon="info-circle" class="mr-2"></b-icon>Please note, if any of the selected info is not available in the system, password won't be applied
                    </div>

                </div>
                <div class="col-md-12 px-3">
                    <div class="col-sm-6 company-form-box-title mt-3 pl-0 mb-2">HR Admin Template</div>
                    <b-form-group label="1.	Show Software information on footer:" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="fdata.core_hr_template_footer"
                            :options="owner_p_setting_option"
                            :aria-describedby="ariaDescribedby"
                            name="core_hr_template_footer"
                            plain
                        ></b-form-radio-group>
                    </b-form-group>


                    <b-form-group label="2.	Select Component for Annual Salary:" v-slot="{ ariaDescribedby }">
                        <b-form-radio-group
                            v-model="fdata.core_hr_template_annual_salary"
                            :options="annual_salary_setting_option"
                            :aria-describedby="ariaDescribedby"
                            name="core_hr_template_annual_salary"
                            plain
                        ></b-form-radio-group>
                    </b-form-group>

                    <b-form-group id="annual_salary_multiplier-group" label="3.	Multiplier for Annual Salary:" class="required-field" label-for="annual_salary_multiplier">
                        <b-input-group class="mb-3">
                        <b-form-input id="annual_salary_multiplier" name="annual_salary_multiplier" v-model="fdata.annual_salary_multiplier" v-validate="{required:true, numeric: true }" type="text" placeholder="12" autocomplete="off" :state="validateState('annual_salary_multiplier')" aria-describedby="annual_salary_multiplier-feedback" data-vv-as="Multiplier"></b-form-input>
                        <b-form-invalid-feedback id="annual_salary_multiplier-feedback">{{ veeErrors.first('annual_salary_multiplier') }}</b-form-invalid-feedback>
                        </b-input-group>
                    </b-form-group>

                </div>

            </div>
                <template v-if="!disabled_by_acl">
                    <template v-if="this.flg == 1">

                        <b-button type="submit" @click="set_go_next()" variant="primary" class="float-right mt-3 mr-3">Save & Go Next</b-button>
                        <b-button type="button" @click="set_go_next(1)" variant="primary" class="float-right mt-3 mr-3">Skip</b-button>
                        <b-button type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go Back</b-button>
                        <b-button type="submit" @click="setfinish()" variant="primary" class="float-right mt-3 mx-3">Finish</b-button>
                    </template>
                    <template v-else>
                        <div class="col-md-12 px-3">
                            <b-button type="submit" @click="disable_set_go_next()" variant="success" class="float-right mt-3">Save</b-button>
                        </div>
                    </template>
                </template>


            </b-overlay>
        </fieldset> -->


        <!-- Abdullah added this code  -->
            <b-overlay :show="showoverlay" rounded="sm">

                <!-- barsha -->
                <div class="row px-3">
                    <!-- FIX 1: was @submit.stop.prevent="formSubmit" — method did not exist, changed to onSubmit -->
                    <form enctype="multipart/form-data" @submit.stop.prevent="onSubmit" style="width: 100%;">
                        <fieldset :disabled="disabled_by_acl">
                            <input type="hidden" v-model="fdata.id" name="id">
                            <div id="settings">

                                <!-- {{ successmsg }} -->

                                <div class="clearfix rounded ibox-content px-0">
                                    <div class="clearfix row no-margin">
                                        <div class="col-md-12 fixed-section-one mb-4 px-0">
                                            <div class="clearfix approval-container row bg-white">

                                                <div class="col-4">
                                                    <div class="approve-level-title">
                                                        Decimal Places
                                                    </div>
                                                </div>
                                                <div class="col-8 approve-level-content py-4 ">
                                                    <div class="clearfix rounded px-0 service_length_settings">
                                                        <p class="service_length_title salary-heads">Please select your
                                                            desired
                                                            option <b-icon class="" icon="info-circle"
                                                                title="Service length will show on all reports and slips in selected format"
                                                                v-b-tooltip></b-icon></p>

                                                        <div class="pl-5">
                                                            <div class="toggle_button_tax first salary-heads d-flex">
                                                                <div class="cmp-child-items"><span
                                                                        class="cmp-outer-circle mr-2"><span
                                                                            class="cmp-inner-circle"></span></span>2 decimal places</div>
                                                                <div
                                                                    class="trz_service_button px-0 cmp-child-items text-right">
                                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                        <input data-v-25adc6c0="" type="radio"
                                                                            v-model="fdata.decimal_point_settings"
                                                                            class="v-switch-input trz_tax_radio"
                                                                            name="decimal_point_settings" value="yes">
                                                                        <div data-v-25adc6c0="" class="v-switch-core"
                                                                            style="width: 50px; height: 22px;  background-color: #CC5057;  border-radius: 11px;">
                                                                            <div data-v-25adc6c0=""
                                                                                class="v-switch-button radio_btn_whitedote">
                                                                            </div>
                                                                        </div> <!---->
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <div class="toggle_button_tax first salary-heads d-flex">
                                                                <div class="cmp-child-items"><span
                                                                        class="cmp-outer-circle mr-2"><span
                                                                            class="cmp-inner-circle"></span></span>Rounded
                                                                    to closest integer.</div>
                                                                <div
                                                                    class="trz_service_button px-0 cmp-child-items text-right">
                                                                    <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                                                        <input data-v-25adc6c0="" type="radio"
                                                                            v-model="fdata.decimal_point_settings"
                                                                            class="v-switch-input trz_tax_radio"
                                                                            name="decimal_point_settings" value="no">
                                                                        <div data-v-25adc6c0="" class="v-switch-core"
                                                                            style="width: 50px; height: 22px;  background-color: #CC5057;  border-radius: 11px;">
                                                                            <div data-v-25adc6c0=""
                                                                                class="v-switch-button radio_btn_whitedote">
                                                                            </div>
                                                                        </div> <!---->
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>



                                                    <template v-if="fdata.decimal_point_settings == 'no'">
                                                        <div class="row">
                                                            <div class="col-md-12">
                                                                <div class="card text-left mb-4 mt-3 gray-border no-shadow border-2 radius-8">
                                                                    <div class="card-body">
                                                                        <div class="row ">
                                                                            <div
                                                                                class="col-md-12 d-flex justify-content-center flex-column border-bottom">
                                                                                <h5 class="mb-2 ">Rounding to the Nearest Integer</h5>
                                                                                <p class="mb-4 text-secondary">The most common type of rounding
                                                                            is to round to the nearest
                                                                            integer. The rule for
                                                                            rounding is simple; look at the
                                                                            digits in the tenth's place (the
                                                                            first digit to
                                                                            the right of the decimal point).
                                                                            If the digit in the tenths place
                                                                            is less than
                                                                            5, then <strong>round
                                                                                down</strong>, which means
                                                                            the units digit remains the
                                                                            same: When digit in the tenths
                                                                            place is 5 or greater, then
                                                                            <strong>round
                                                                                up</strong>, which means you
                                                                            should increase the unit digit
                                                                            by one.</p>
                                                                            </div>
                                                                        </div>
                                                                        <div class="row mt-4">
                                                                            <div class="col-md-2 text-right"><b-icon
                                                                                    icon="exclamation-triangle"
                                                                                    style="width: 90px; height: 90px;"
                                                                                    variant="danger"
                                                                                    class="align-custom"></b-icon></div>
                                                                            <div
                                                                                class="col-md-10 d-flex justify-content-center flex-column">
                                                                                <h5 class="mb-2 text-danger">Disclaimer</h5>
                                                                                <p class="mb-0 text-secondary mb-4">Please note
                                                                                    rounding of figures
                                                                                    may result in nominal
                                                                                    differences due to the
                                                                                    impact of fractions. AccordHRM will
                                                                                    not be responsible for any under
                                                                                    or over
                                                                                    deductions and/or payments due
                                                                                    to such differences.</p>
                                                                            </div> <!--Mustafijur: 24-06-2026: ATL HR to AccordHRM-->
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <!-- <div class="card h-100 red-shadow">
                                                                    <div class="card-body">
                                                                        <h5 class="mb-3 border-bottom pb-3">
                                                                            <b-icon icon="info-circle"
                                                                                class="mr-2 align-custom"></b-icon>Disclaimer
                                                                        </h5>
                                                                        <p>Please note rounding of figures
                                                                            may result in nominal
                                                                            differences due to the
                                                                            impact of fractions. ATL HR will
                                                                            not be responsible for any under
                                                                            or over
                                                                            deductions and/or payments due
                                                                            to such differences.</p>
                                                                    </div>
                                                                </div> -->
                                                            </div>
                                                            <!-- <div class="col-md-12">
                                                                <div class="card text-left mb-4 mt-3 gray-border no-shadow border-2 radius-8">
                                                                    <div class="card-body">
                                                                        <div class="row">
                                                                            <div
                                                                                class="col-md-12 d-flex justify-content-center flex-column">
                                                                                <h5 class="mb-2 ">Rounding to the Nearest Integer</h5>
                                                                                <p class="mb-0 text-secondary">The most common type of rounding
                                                                            is to round to the nearest
                                                                            integer. The rule for
                                                                            rounding is simple; look at the
                                                                            digits in the tenth's place (the
                                                                            first digit to
                                                                            the right of the decimal point).
                                                                            If the digit in the tenths place
                                                                            is less than
                                                                            5, then <strong>round
                                                                                down</strong>, which means
                                                                            the units digit remains the
                                                                            same: When digit in the tenths
                                                                            place is 5 or greater, then
                                                                            <strong>round
                                                                                up</strong>, which means you
                                                                            should increase the unit digit
                                                                            by one.</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div> -->
                                                        </div>

                                                    </template>




                                                    <!-- <table class="table table-sm first-child-no-border">

                                                        <tbody> <template>
                                                                <tr class="align-middle">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Please select your desired option
                                                                    </td>
                                                                    <template>
                                                                        <td class="col-md-5 text-right pr-0 py-2">
                                                                            <toggle-button
                                                                                v-model="fdata.decimal_point_settings"
                                                                                :value="status == '1'"
                                                                                :color="{ checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F' }" />
                                                                        </td>
                                                                    </template>

                                                                </tr>
                                                            </template></tbody>

                                                    </table> -->

                                                </div>
                                                <div class="col-4">
                                                    <div class="approve-level-title">
                                                        Password Protection
                                                    </div>
                                                </div>
                                                <div class="col-8 approve-level-content py-0 ">
                                                    <table class="table table-sm first-child-no-border">

                                                        <tbody> <template>
                                                                <tr class="align-middle border-top">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Set master password for Pay Slips and tax Cards
                                                                    </td>
                                                                    <template>
                                                                        <td class="col-md-5 text-right pr-0 py-2">
                                                                            <!-- FIX 2: removed invalid :options, :aria-describedby, name, plain props from toggle-button -->
                                                                            <!-- FIX 3: toggle-button expects Boolean — use :value + @change instead of v-model with string -->
                                                                            <toggle-button
                                                                                :value="fdata.owner_password_settings === 'yes'"
                                                                                @change="fdata.owner_password_settings = $event.value ? 'yes' : 'no'"
                                                                                :color="{ checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F' }" />
                                                                        </td>
                                                                    </template>
                                                                </tr>
                                                                <!-- FIX 4: was == true (always false for string), now === 'yes' -->
                                                                <tr v-if="fdata.owner_password_settings === 'yes'">
                                                                    <template>
                                                                        <div class="row">
                                                                            <div class="col-md-12">
                                                                                <b-input-group
                                                                                    label="Password(4 characters minimum):"
                                                                                    minlength="4"
                                                                                    class="text-left mb-5 max-250">
                                                                                    <b-form-input
                                                                                        v-model="fdata.owner_password"
                                                                                        :type="type" name="owner_password"
                                                                                        placeholder="Enter your password"
                                                                                        pattern=".{4,}"
                                                                                        description="please enter a password "
                                                                                        title="Password should be at least 4 characters long"
                                                                                        required></b-form-input>
                                                                                    <b-input-group-append>
                                                                                        <b-button variant="outline-success"
                                                                                            @click="showPassword()"><b-icon
                                                                                                icon="eye-fill"></b-icon></b-button>
                                                                                    </b-input-group-append>
                                                                                </b-input-group>
                                                                                <!-- end of password input -->
                                                                            </div>
                                                                        </div>

                                                                    </template>
                                                                </tr>
                                                                <tr class="align-middle">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Password protect pay slips and tax cards for Each
                                                                        employee
                                                                    </td>
                                                                    <template>
                                                                        <td class="col-md-5 text-right pr-0 py-2">
                                                                            <!-- FIX 5: same boolean conversion fix for employee toggle -->
                                                                            <toggle-button
                                                                                :value="fdata.employee_password_settings === 'yes'"
                                                                                @change="fdata.employee_password_settings = $event.value ? 'yes' : 'no'"
                                                                                :color="{ checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F' }" />
                                                                        </td>
                                                                    </template>

                                                                </tr>
                                                                <!-- FIX 6: was == true, now === 'yes' -->
                                                                <tr v-if="fdata.employee_password_settings === 'yes'">
                                                                    <div class="col-md-12">
                                                                        <b-form-group label="Select password type:"
                                                                            v-slot="{ ariaDescribedby }">
                                                                            <b-form-radio-group
                                                                                v-model="fdata.employee_passworod_type"
                                                                                :options="employee_p_type_option"
                                                                                :aria-describedby="ariaDescribedby"
                                                                                name="employee_password_type"
                                                                                class="employee-pass-settings mb-2"
                                                                                plain></b-form-radio-group>
                                                                        </b-form-group>
                                                                    </div>
                                                                </tr>
                                                            </template></tbody>

                                                    </table>

                                                </div>

                                                <div class="col-4">
                                                    <div class="approve-level-title pt-2">
                                                        HR Admin Portal Template
                                                    </div>
                                                </div>
                                                <div class="col-8 approve-level-content py-0 ">
                                                    <table class="table table-sm first-child-no-border">

                                                        <tbody>
                                                            <template>
                                                                <tr class="align-middle border-top">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Show Software information on footer
                                                                    </td>
                                                                    <template>
                                                                        <td class="col-md-5 text-right pr-0 py-2">
                                                                            <!-- FIX 7: removed invalid props, boolean conversion for footer toggle -->
                                                                            <toggle-button :key="'footer-' + fdata.core_hr_template_footer"
                                                                                :value="fdata.core_hr_template_footer === 'yes'"
                                                                                @change="fdata.core_hr_template_footer = $event.value ? 'yes' : 'no'"
                                                                                :color="{ checked: '#01524B', unchecked: '#CC5057', disabled: '#8F8F8F' }" />
                                                                        </td>
                                                                    </template>
                                                                </tr>

                                                                <!-- Annual Salary Component — table row design matching other rows -->
                                                                <tr class="align-middle border-top">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Select Component for Annual Salary
                                                                    </td>
                                                                    <td class="col-md-5 text-right pr-0 py-2">
                                                                        <!-- Abdullah 13-05-26 added this clas -->
                                                                        <b-form-radio-group
                                                                            v-model="fdata.core_hr_template_annual_salary"
                                                                            :options="annual_salary_setting_option"
                                                                            name="core_hr_template_annual_salary"
                                                                            plain


                                                                            class="other-settings-custom-radio-font"
                                                                        ></b-form-radio-group>
                                                                    </td>
                                                                </tr>

                                                                <!-- Multiplier for Annual Salary — table row design matching other rows -->
                                                                <tr class="align-middle border-top">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Multiplier for Annual Salary
                                                                    </td>
                                                                    <td class="col-md-5 text-right pr-0 py-2">
                                                                        <b-input-group class="max-250 ml-auto">
                                                                            <b-form-input
                                                                                id="annual_salary_multiplier"
                                                                                name="annual_salary_multiplier"
                                                                                v-model="fdata.annual_salary_multiplier"
                                                                                v-validate="{required:true, numeric: true}"
                                                                                type="text"
                                                                                placeholder="12"
                                                                                autocomplete="off"
                                                                                :state="validateState('annual_salary_multiplier')"
                                                                                aria-describedby="annual_salary_multiplier-feedback"
                                                                                data-vv-as="Multiplier"
                                                                                class="radius-8"
                                                                            ></b-form-input>
                                                                            <b-form-invalid-feedback id="annual_salary_multiplier-feedback">{{ veeErrors.first('annual_salary_multiplier') }}</b-form-invalid-feedback>
                                                                        </b-input-group>
                                                                    </td>
                                                                </tr>

                                                                <!-- Afrin: added 8-3-26 start-->
                                                                <tr class="align-middle border-top">
                                                                    <td class="col-md-7 pl-0 py-2 salary-heads">
                                                                        Payroll Component Calculation
                                                                    </td>
                                                                    <td class="col-md-5 text-right pr-0 py-2">
                                                                        <b-form-radio-group
                                                                            v-model="fdata.payroll_component_calculation"
                                                                            :options="payroll_component_calculation_options"
                                                                            name="payroll_component_calculation"
                                                                            plain
                                                                            class="other-settings-custom-radio-font"
                                                                        ></b-form-radio-group>
                                                                    </td>
                                                                </tr>
                                                                <!-- Afrin: added 8-3-26 end-->

                                                            </template>
                                                        </tbody>

                                                    </table>

                                                </div>

                                                <template v-if="this.flg == 1">

                                                    <div class="text-center">
                                                        <b-button type="submit" @click="set_go_next()" variant="primary"
                                                            class="btn-primary mt-3 mr-3 ">Save & Go
                                                            Next</b-button>
                                                        <b-button type="button" @click="set_go_next(1)" variant="primary"
                                                            class="btn-primary mt-3 mr-3">Skip</b-button>
                                                        <b-button type="button" @click="set_go_back(1)" variant="primary"
                                                            class="btn-primary mt-3 mr-3">Go
                                                            Back</b-button>
                                                        <b-button type="submit" @click="setfinish()" variant="primary"
                                                            class="btn-primary mt-3 mx-3">Finish</b-button>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <div class="col-md-12 px-3 text-center mb-4">
                                                        <b-button type="submit" @click="disable_set_go_next()"
                                                            variant="success" class="btn-primary mt-3">Save</b-button>
                                                    </div>
                                                </template>


                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </fieldset>
                    </form>
                </div>
                <!-- barsha -->
                <!-- <div class="clearfix company-other-settings">
                    <div class="col-md-12 px-3">


                        <div class="col-sm-6 company-form-box-title pl-0 mb-2">Decimal Places</div>
                        <p>Please select your desired option</p>
                        <div class="toggle_button_tax">
                            <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                    <input data-v-25adc6c0="" type="radio" v-model="fdata.decimal_point_settings"
                                        class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="yes">
                                    <div data-v-25adc6c0="" class="v-switch-core"
                                        style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                        <div data-v-25adc6c0="" class="v-switch-button"></div>
                                    </div>
                                </label>
                            </div>
                            <div class="col-sm-3 trz_tax_button ">Yes - 2 decimal places</div>
                        </div>
                        <div class="toggle_button_tax">
                            <div class="col-sm-1 trz_tax_button px-0 tax_toggle">
                                <label data-v-25adc6c0="" class="vue-js-switch toggled">
                                    <input data-v-25adc6c0="" type="radio" v-model="fdata.decimal_point_settings"
                                        class="v-switch-input trz_tax_radio" name="decimal_point_settings" value="no">
                                    <div data-v-25adc6c0="" class="v-switch-core"
                                        style="width: 50px; height: 22px;  background-color: rgb(227, 52, 47);  border-radius: 11px;">
                                        <div data-v-25adc6c0="" class="v-switch-button"></div>
                                    </div>
                                </label>
                            </div>
                            <div class="col-sm-3 trz_tax_button ">No - Rounded to closest integer.</div>
                        </div>


                        <div class="row mt-3" v-if="fdata.decimal_point_settings == 'no'">

                            <div class="col-md-6">
                                <div class="card h-100 red-shadow">
                                    <div class="card-body">
                                        <h5 class="mb-3 border-bottom pb-3"><b-icon icon="info-circle"
                                                class="mr-2 align-custom"></b-icon>Disclaimer</h5>
                                        <p>Please note rounding of figures may result in nominal differences due to the
                                            impact of fractions. ATL HR will not be responsible for any under or over
                                            deductions and/or payments due to such differences.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="card h-100">
                                    <div class="card-body">
                                        <h5 class="mb-3 border-bottom pb-3"><b-icon icon="info-circle"
                                                class="mr-2 align-custom"></b-icon>Rounding to the Nearest Integer</h5>
                                        <p>The most common type of rounding is to round to the nearest integer. The rule for
                                            rounding is simple; look at the digits in the tenth's place (the first digit to
                                            the right of the decimal point). If the digit in the tenths place is less than
                                            5, then <strong>round down</strong>, which means the units digit remains the
                                            same: When digit in the tenths place is 5 or greater, then <strong>round
                                                up</strong>, which means you should increase the unit digit by one.</p>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="col-sm-6 company-form-box-title mt-3 pl-0 mb-2">Password Protection</div>
                        <b-form-group label="1.	Set master password for payslips and taxcards:"
                            v-slot="{ ariaDescribedby }">
                            <b-form-radio-group v-model="fdata.owner_password_settings" :options="owner_p_setting_option"
                                :aria-describedby="ariaDescribedby" name="owner_password_settings"
                                plain></b-form-radio-group>

                        </b-form-group>
                        <div class="row" v-if="fdata.owner_password_settings == 'yes'">
                            <div class="col-md-6">

                                <div class="row">
                                    <div class="col-md-12">
                                        <b-input-group label="Password(4 characters minimum):" minlength="4"
                                            class="text-left mb-5 max-250">
                                            <b-form-input v-model="fdata.owner_password" :type="type" name="owner_password"
                                                placeholder="Enter your password" pattern=".{4,}"
                                                description="please enter a password "
                                                title="Password should be at least 4 characters long"
                                                required></b-form-input>
                                            <b-input-group-append>
                                                <b-button variant="outline-success" @click="showPassword()"><b-icon
                                                        icon="eye-fill"></b-icon></b-button>
                                            </b-input-group-append>
                                        </b-input-group>

                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>

                    <div class="col-md-12 px-3">
                        <b-form-group label="2.	Password protect payslips and taxcards for employees:"
                            v-slot="{ ariaDescribedby }">
                            <b-form-radio-group v-model="fdata.employee_password_settings"
                                :options="employee_p_setting_option" :aria-describedby="ariaDescribedby"
                                name="employee_password_settings" plain></b-form-radio-group>
                        </b-form-group>
                        <div class="row" v-if="fdata.employee_password_settings == 'yes'">
                            <div class="col-md-12">
                                <b-form-group label="Select password type:" v-slot="{ ariaDescribedby }">
                                    <b-form-radio-group v-model="fdata.employee_passworod_type"
                                        :options="employee_p_type_option" :aria-describedby="ariaDescribedby"
                                        name="employee_password_type" class="employee-pass-settings mb-2"
                                        plain></b-form-radio-group>
                                </b-form-group>
                            </div>
                        </div>
                        <div class="col-md-12 px-0">
                            <b-icon icon="info-circle" class="mr-2"></b-icon>Please note, if any of the selected info is not
                            available in the system, password won't be applied
                        </div>

                    </div>

                </div>

                <template v-if="this.flg == 1">

                    <b-button type="submit" @click="set_go_next()" variant="primary" class="float-right mt-3 mr-3">Save & Go
                        Next</b-button>
                    <b-button type="button" @click="set_go_next(1)" variant="primary"
                        class="float-right mt-3 mr-3">Skip</b-button>
                    <b-button type="button" @click="set_go_back(1)" variant="primary" class="float-right mt-3 mr-3">Go
                        Back</b-button>
                    <b-button type="submit" @click="setfinish()" variant="primary"
                        class="float-right mt-3 mx-3">Finish</b-button>
                </template>
                <template v-else>
                    <div class="col-md-12 px-3">
                        <b-button type="submit" @click="disable_set_go_next()" variant="success"
                            class="float-right mt-3">Save</b-button>
                    </div>
                </template> -->


            </b-overlay>



    </b-form>

    </div>
</template>
<script>
    export default{

        mounted() {
            //
            if(this.$acl['company/saveothersettings'] == 2)
                this.disabled_by_acl = false;
        },
        props: [ 'flg'],
        components: {
        },
        data(){

            return {
                 owner_p_setting_option: [
                    { text: 'Yes', value: 'yes' },
                    { text: 'No', value: 'no' },
                    ],
                 employee_p_setting_option: [
                    { text: 'Yes', value: 'yes' },
                    { text: 'No', value: 'no' },
                    ],
                 employee_p_type_option: [
                    { text: 'DOB', value: 'dob' },
                    // { text: 'NID/Passport Number', value: 'nid_or_passport' }, // Mustafijur: Commented out on 03-03-2026
                    { text: 'NID', value: 'nid' }, // Mustafijur: Added on 03-03-2026
                    { text: 'Passport Number', value: 'passport' }, // Mustafijur: Added on 03-03-2026
                    { text: 'e-TIN ( Last 4 Digit of e-Tin )', value: 'etin' },
                    { text: 'Custom ( Capitalized first letter of name + year of birth + last 4 digits of mobile number. Example: A19849198 )', value: 'custom' },
                    ],
                cu:window.location.href,
                ce:false,
                successmsg : false,
                warningmsg : false,
                dangermsg : false,
                showoverlay : false,
                go_back : false,
                go_next : false,
                finish : false,
                errormsg:[],
                fdata: {
                    employee_password_settings: 'no',
                    owner_password_settings: 'no',
                    employee_passworod_type:'dob' ,
                    owner_password: '',
                    decimal_point_settings:'no',
                    core_hr_template_footer:'yes',
                    core_hr_template_annual_salary:'1',  //ANNUAL SALARY
                    annual_salary_multiplier:'12',  //ANNUAL SALARY
                    payroll_component_calculation: 'payroll_salary', // Afrin: added 8-3-26
                },

                type: 'password',
                disabled_by_acl : true,
                btnText: 'Show Password',

                //ANNUAL SALARY
                annual_salary_setting_option: [
                    { text: 'Gross Salary', value: '1' },
                    { text: 'Basic Salary', value: '2' },
                ],
                //ANNUAL SALARY

                // Afrin: added 8-3-26 start
                payroll_component_calculation_options: [
                    { text: 'Payroll Salary', value: 'payroll_salary' },
                    { text: 'Contacted Salary', value: 'contacted_salary' },
                ],
                // Afrin: added 8-3-26 end

            }
        },
        methods:{


            showMessage: function()
            {
                let tmp_flg = 0;
                if(this.fdata.tax_zone != null)
                {
                    if(this.fdata.tax_zone.length > 0)tmp_flg = 1;
                }
                let childdata = {flg:tmp_flg , successmsg:this.successmsg , warningmsg:this.warningmsg , dangermsg:this.dangermsg,  move_next:this.go_next , move_back:this.go_back , finish:this.finish};
                this.$emit('childToParent', childdata);
            },
            set_go_back(x){
                this.go_next = false;
                this.go_back = true;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            set_go_next(x){
                this.go_next = true;
                this.go_back = false;
                this.finish = false;

                if(x == 1)
                    this.showMessage();
            },
            disable_set_go_next(){
                this.go_next = false;
            },
               getAcl: function()
            {
                axios.get(this.$api_url+'/acl' , {
                    params: {
                        url: this.cu
                    }
                }).then(function(response){
                    this.ce = response.data;
                }.bind(this));
            },
             showPassword() {
                    if(this.type === 'password') {
                        this.type = 'text'
                        this.btnText = 'Hide Password'
                    } else {
                        this.type = 'password'
                        this.btnText = 'Show Password'
                    }
                },
            getPasswordSettings: function()
            {

                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/password-settings' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    this.fdata.employee_password_settings = response.data.employee_password_settings_for_payslip_tax_card;
                    this.fdata.owner_password_settings = response.data.owner_password_settings_for_payslip_tax_card;
                    this.fdata.decimal_point_settings = response.data.decimal_point_settings;
                    this.fdata.core_hr_template_footer = response.data.core_hr_template_footer;
                    
                   

                    //ANNUAL SALARY
                    if (response.data && response.data.core_hr_template_annual_salary !== undefined && response.data.core_hr_template_annual_salary !== null && response.data.core_hr_template_annual_salary !== ''
                    ) {
                        this.fdata.core_hr_template_annual_salary = response.data.core_hr_template_annual_salary;
                    }

                    if (response.data && response.data.annual_salary_multiplier !== undefined && response.data.annual_salary_multiplier !== null && response.data.annual_salary_multiplier !== ''
                    ) {
                        this.fdata.annual_salary_multiplier = response.data.annual_salary_multiplier;
                    }
                    //ANNUAL SALARY

                    //Afrin: added 8-3-26 start

                    if (response.data && response.data.payroll_component_calculation !== undefined && response.data.payroll_component_calculation !== null && response.data.payroll_component_calculation !== ''
                    ) {
                        this.fdata.payroll_component_calculation = response.data.payroll_component_calculation;
                    }
                    //Afrin: added 8-3-26 end

                    if( response.data.employee_password_settings_for_payslip_tax_card == "yes"){
                        this.fdata.employee_passworod_type = response.data.employee_password_settings_type;
                    }
                    if(response.data.owner_password_settings_for_payslip_tax_card == "yes"){
                        this.fdata.owner_password = response.data.owner_password;
                    }


                }.bind(this)).catch(function (error){
                    this.serverError(error);
                    });
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.successmsg = false;
                this.warningmsg = false;
                this.dangermsg = false;
                //this.showMessage();
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    this.showoverlay = true;

                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();


                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                    }

                    axios.post(this.$api_url+'/company/saveothersettings', formData, config)
                            .then(function (response)
                            {
                                console.log(response.data);
                    this.fdata.employee_password_settings = response.data.employee_password_settings_for_payslip_tax_card;
                    this.fdata.owner_password_settings = response.data.owner_password_settings_for_payslip_tax_card;
                    this.fdata.decimal_point_settings = response.data.decimal_point_settings;
                    if( response.data.employee_password_settings_for_payslip_tax_card == "yes"){
                      this.fdata.employee_passworod_type = response.data.employee_password_settings_type_for_payslip_tax_card;
                       }
                    if(response.data.owner_password_settings_for_payslip_tax_card == "yes"){
                      this.fdata.owner_password = response.data.owner_password_for_payslip_tax_card;
                     }
                     this.$bvToast.toast('Other Settings Saved!', {title: `Success`,variant: 'success',solid: true});
                                this.showoverlay = false;
                                this.$validator.reset();

                                this.showMessage();

                            }.bind(this))
                            .catch(function (error)
                            {
                                currentObj.showoverlay = false;
                                currentObj.serverError(error);
                                currentObj.errormsg = error.response.data.errors;
                                for (var data in currentObj.errormsg)
                                {
                                    var msg = currentObj.errormsg[data];
                                    currentObj.$bvToast.toast(msg, {
                                        title: `Error`,
                                        variant: 'danger',
                                        solid: true
                                    });
                                    currentObj.$validator.reset();
                                }
                            });
                });
            },

        },
        created: function(){

            this.getPasswordSettings();
            this.getAcl();
            this.$validator.reset();


        }
    }
</script>
